import { PeopleSelector } from '../../components/PeopleSelector';

interface Props {
  value: number;
  max: number;
  mode: 'instant' | 'request';
  slotPicked: boolean;
  onChange: (v: number) => void;
  onNext: () => void;
}

export function PartyStep({ value, max, mode, slotPicked, onChange, onNext }: Props) {
  // Instant: capacidade do slot é teto rígido. OnRequest: operador decide.
  const effectiveMax = mode === 'instant' ? max : 20;
  const hint =
    mode === 'request'
      ? 'Capacidade confirmada pelo operador.'
      : slotPicked && max < 20
        ? `Máximo ${max} ${max === 1 ? 'pessoa' : 'pessoas'} neste horário`
        : undefined;

  return (
    <div className="step">
      <h2 className="step__title">Quantas pessoas?</h2>
      <p className="step__lead">Inclua você no total.</p>

      <PeopleSelector value={value} onChange={onChange} max={effectiveMax} hint={hint} />

      <div className="step__cta-row">
        <button type="button" className="btn btn--brand btn--lg btn--block" onClick={onNext}>
          Continuar
        </button>
      </div>
    </div>
  );
}
